import { Seo } from '../components/Seo';
import { FaqList, CtaSection } from '../components/Sections';
import { TransactionSupportCard } from '../components/TransactionSupportCard';
import { useT } from '../i18n';
import { buildTitle } from '../lib/site';

export function FaqPage() {
  const t = useT();
  const p = t.pages.faq;
  return (
    <>
      <Seo
        title={buildTitle(p.title)}
        description={p.lead}
        path="/faq"
      />

      <section className="page-header">
        <div className="container">
          <span className="eyebrow">{p.eyebrow}</span>
          <h1>{p.title}</h1>
          <p>{p.lead}</p>
        </div>
      </section>

      <section className="section">
        <div className="container container-narrow">
          <FaqList items={t.faqs} />

          <TransactionSupportCard
            eyebrow={p.transactionSupportEyebrow}
            title={p.transactionSupportTitle}
            description={p.transactionSupportDesc}
            cta={p.transactionSupportCta}
          />

          {/* JSON-LD FAQ structured data */}
          <script
            type="application/ld+json"
            dangerouslySetInnerHTML={{
              __html: JSON.stringify({
                '@context': 'https://schema.org',
                '@type': 'FAQPage',
                mainEntity: t.faqs.map((f) => ({
                  '@type': 'Question',
                  name: f.q,
                  acceptedAnswer: { '@type': 'Answer', text: f.a },
                })),
              }),
            }}
          />
        </div>
      </section>

      <CtaSection />
    </>
  );
}
